import * as Yup from 'yup'

import { EMPTY_OBJECT, NOTIFICATION_TYPE } from '../../constants/common'
import { isFormFieldsEqual } from '../../utils/formHelpers'

import {
  FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
  FORM_FIELD_NAME_NO_CHANGED,
  FORM_NOTIFICATION_NAME_RESPONSIBLE_MANAGERS_LIMIT,
  RESPONSIBLE_MANAGERS_LIMIT,
} from './Form.constants'

export function isFormErrorNameResponsibleManagersLimitExceeded(error) {
  return error === FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED
}

export function formValidationSchemaNoChanged({
  initialValues,
  isEqual = isFormFieldsEqual,
  isEqualProps = EMPTY_OBJECT,
}) {
  return Yup.object({
    [FORM_FIELD_NAME_NO_CHANGED]: Yup.mixed().notRequired(),
  }).test({
    name: 'changed',
    test: function (values) {
      if (!values) {
        return true
      }

      const changed = !isEqual({ ...isEqualProps, initialValues, values })

      if (changed) {
        return true
      }

      return this.createError({
        path: FORM_FIELD_NAME_NO_CHANGED,
      })
    },
  })
}

export function getResponsibleManagersExceededNotification(t) {
  return {
    id: FORM_NOTIFICATION_NAME_RESPONSIBLE_MANAGERS_LIMIT,
    text: t('Error.ResponsibleManagersLimitExceededInfoKey', {
      limit: RESPONSIBLE_MANAGERS_LIMIT,
    }),
    type: NOTIFICATION_TYPE.info,
  }
}
